import { t } from '@lingui/macro';

export const options = [t`My Notes`];
export const getOptions = () => {
    return options;
};
